import axios from 'axios'

export default {
  state: {
    categories: [],
    category: {},
    persons: [],
    person: {},
    story: {},
  },
  getters: {
    categories(state) {
      return state.categories
    },
    category(state) {
      return state.category
    },
    persons(state) {
      return state.persons
    },
    person(state) {
      return state.person
    },
    story(state) {
      return state.story
    },
  },
  mutations: {
    updateCategories(state, categories) {
      state.categories = categories
    },
    updateCategory(state, category) {
      state.category = category
    },
    updatePersons(state, persons) {
      state.persons = persons
    },
    updatePerson(state, person) {
      state.person = person
    },
    updateStory(state, story) {
      state.story = story
    },
  },
  actions: {
    getAllCategories(ctx) {
      return axios({
        method: 'GET',
        url: 'api/success/category/',
      })
        .then((response) => {
          const categories = response.data
          ctx.commit('updateCategories', categories)
        })
        .catch((error) => {
          console.error(error)
        })
    },

    getCategory(ctx, { id }) {
      if (!id || id === '') {
        return
      }
      return axios({
        method: 'GET',
        url: `api/success/category/${id}/`,
      })
        .then((response) => {
          const category = response.data
          ctx.commit('updateCategory', category)
        })
        .catch((error) => {
          console.error(error)
        })
    },

    filterCategory(ctx, { id, slug, page, pageSize, year, month, name }) {
      if ((!id || id === '') && (!slug || slug === '')) {
        return
      }
      let url = `api/success/person/filter/?page=${page}&page_size=${pageSize}`
      if (year && year !== '') {
        url += `&nomination_date__year=${year}`
      }
      if (id && id !== '') {
        url += `&category_id=${id}`
      }
      if (slug && slug !== '') {
        url += `&category__slug=${slug}`
      }
      if (year !== '' && month !== '') {
        url += `&nomination_date__month=${month}`
      }
      if (name !== '') {
        url += `&name__icontains=${name}`
      }
      return axios({
        method: 'GET',
        url: url,
      })
        .then((response) => {
          const persons = response.data
          ctx.commit('updatePersons', persons)
        })
        .catch((error) => {
          console.error(error)
        })
    },

    getPerson(ctx, { id }) {
      if (!id || id === '') {
        return
      }
      return axios({
        method: 'GET',
        url: `api/success/person/${id}/`,
      })
        .then((response) => {
          const person = response.data
          ctx.commit('updatePerson', person)
        })
        .catch((error) => {
          console.error(error)
        })
    },

    getStory(ctx, { id }) {
      if (!id || id === '') {
        return
      }
      return axios({
        method: 'GET',
        url: `api/success/story/${id}/`,
      })
        .then((response) => {
          const story = response.data
          ctx.commit('updateStory', story)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    StorySetView(ctx, id) {
      return axios({
        method: 'POST',
        url: `api/success/story/${id}/view/`,
      }).catch((error) => {
        console.error(error)
      })
    },
  },
}
